// Simple extraction of chart utility functions - no changes to logic

export const createStripedPattern = (baseColor) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = 20;
  canvas.height = 20;

  // Fill with base color
  ctx.fillStyle = baseColor;
  ctx.fillRect(0, 0, 20, 20);

  // Add diagonal stripes
  ctx.strokeStyle = "rgb(255, 255, 255)";
  ctx.lineWidth = 2;
  ctx.beginPath();

  // Draw diagonal lines
  for (let i = -20; i <= 40; i += 6) {
    ctx.moveTo(i, 0);
    ctx.lineTo(i + 20, 20);
  }

  ctx.stroke();

  return canvas;
};

export const isNumeric = (v) => !isNaN(v) && !isNaN(parseFloat(v));